/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BulkResult,
  BulkUpdateStatus,
  Courier,
  CourierUser,
  DeliveryRequest,
  NewDeliveryRequest,
  RoleMappingCount200Response,
  RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest,
  RoleMappingExistsGetRoleMappingsIdExists200Response,
  RoleMappingUpdateAll200Response,
  Town,
} from '../models/index';
import {
    BulkResultFromJSON,
    BulkResultToJSON,
    BulkUpdateStatusFromJSON,
    BulkUpdateStatusToJSON,
    CourierFromJSON,
    CourierToJSON,
    CourierUserFromJSON,
    CourierUserToJSON,
    DeliveryRequestFromJSON,
    DeliveryRequestToJSON,
    NewDeliveryRequestFromJSON,
    NewDeliveryRequestToJSON,
    RoleMappingCount200ResponseFromJSON,
    RoleMappingCount200ResponseToJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestFromJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON,
    RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON,
    RoleMappingExistsGetRoleMappingsIdExists200ResponseToJSON,
    RoleMappingUpdateAll200ResponseFromJSON,
    RoleMappingUpdateAll200ResponseToJSON,
    TownFromJSON,
    TownToJSON,
} from '../models/index';

export interface DeliveryRequestBulkCreateRequest {
    bulkCreateData: {
        courierId: string;
        requests: Array<Record<string, any>>;
    };
}

export interface DeliveryRequestBulkUpdateStatusRequest {
    bulkUpdateStatus: BulkUpdateStatus;
}

export interface DeliveryRequestCountRequest {
    where?: string;
}

export interface DeliveryRequestCreateRequest {
    data?: NewDeliveryRequest;
}

export interface DeliveryRequestCreateChangeStreamGetDeliveryRequestsChangeStreamRequest {
    options?: string;
}

export interface DeliveryRequestCreateChangeStreamPostDeliveryRequestsChangeStreamRequest {
    roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest?: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest;
}

export interface DeliveryRequestDeleteByIdRequest {
    id: string;
}

export interface DeliveryRequestExistsGetDeliveryRequestsidExistsRequest {
    id: string;
}

export interface DeliveryRequestExistsHeadDeliveryRequestsidRequest {
    id: string;
}

export interface DeliveryRequestFindRequest {
    filter?: string;
}

export interface DeliveryRequestFindByIdRequest {
    id: string;
    filter?: string;
}

export interface DeliveryRequestFindOneRequest {
    filter?: string;
}

export interface DeliveryRequestPatchOrCreateRequest {
    data?: DeliveryRequest;
}

export interface DeliveryRequestPrototypeGetCourierRequest {
    id: string;
    refresh?: boolean;
}

export interface DeliveryRequestPrototypeGetCourierUserRequest {
    id: string;
    refresh?: boolean;
}

export interface DeliveryRequestPrototypeGetDeliveryLocationRequest {
    id: string;
    refresh?: boolean;
}

export interface DeliveryRequestPrototypePatchAttributesRequest {
    id: string;
    data?: DeliveryRequest;
}

export interface DeliveryRequestReplaceByIdPostDeliveryRequestsidReplaceRequest {
    id: string;
    data?: DeliveryRequest;
}

export interface DeliveryRequestReplaceByIdPutDeliveryRequestsidRequest {
    id: string;
    data?: DeliveryRequest;
}

export interface DeliveryRequestReplaceOrCreatePostDeliveryRequestsReplaceOrCreateRequest {
    data?: DeliveryRequest;
}

export interface DeliveryRequestReplaceOrCreatePutDeliveryRequestsRequest {
    data?: DeliveryRequest;
}

export interface DeliveryRequestUpdateAllRequest {
    where?: string;
    data?: DeliveryRequest;
}

export interface DeliveryRequestUpsertWithWhereRequest {
    where?: string;
    data?: DeliveryRequest;
}

export interface DeliveryRequestExportRequest {
    courierId: string;
    date: string;
}

/**
 * 
 */
export class DeliveryRequestApi extends runtime.BaseAPI {

    /**
     * Bulk create delivery requests
     */
    async deliveryRequestBulkCreateRaw(requestParameters: DeliveryRequestBulkCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkResult>> {
        if (requestParameters['bulkCreateData'] == null) {
            throw new runtime.RequiredError(
                'bulkCreateData',
                'Required parameter "bulkCreateData" was null or undefined when calling deliveryRequestBulkCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryRequests/bulkCreate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['bulkCreateData'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkResultFromJSON(jsonValue));
    }

    /**
     * Bulk create delivery requests
     */
    async deliveryRequestBulkCreate(requestParameters: DeliveryRequestBulkCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkResult> {
        const response = await this.deliveryRequestBulkCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deliveryRequestBulkUpdateStatusRaw(requestParameters: DeliveryRequestBulkUpdateStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkResult>> {
        if (requestParameters['bulkUpdateStatus'] == null) {
            throw new runtime.RequiredError(
                'bulkUpdateStatus',
                'Required parameter "bulkUpdateStatus" was null or undefined when calling deliveryRequestBulkUpdateStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryRequests/bulkUpdateStatus`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkUpdateStatusToJSON(requestParameters['bulkUpdateStatus']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkResultFromJSON(jsonValue));
    }

    /**
     */
    async deliveryRequestBulkUpdateStatus(requestParameters: DeliveryRequestBulkUpdateStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkResult> {
        const response = await this.deliveryRequestBulkUpdateStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Count instances of the model matched by where from the data source.
     */
    async deliveryRequestCountRaw(requestParameters: DeliveryRequestCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryRequests/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Count instances of the model matched by where from the data source.
     */
    async deliveryRequestCount(requestParameters: DeliveryRequestCountRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.deliveryRequestCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async deliveryRequestCreateRaw(requestParameters: DeliveryRequestCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryRequest>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryRequests`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewDeliveryRequestToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryRequestFromJSON(jsonValue));
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async deliveryRequestCreate(requestParameters: DeliveryRequestCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryRequest> {
        const response = await this.deliveryRequestCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a change stream.
     */
    async deliveryRequestCreateChangeStreamGetDeliveryRequestsChangeStreamRaw(requestParameters: DeliveryRequestCreateChangeStreamGetDeliveryRequestsChangeStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters['options'] != null) {
            queryParameters['options'] = requestParameters['options'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryRequests/change-stream`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create a change stream.
     */
    async deliveryRequestCreateChangeStreamGetDeliveryRequestsChangeStream(requestParameters: DeliveryRequestCreateChangeStreamGetDeliveryRequestsChangeStreamRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.deliveryRequestCreateChangeStreamGetDeliveryRequestsChangeStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a change stream.
     */
    async deliveryRequestCreateChangeStreamPostDeliveryRequestsChangeStreamRaw(requestParameters: DeliveryRequestCreateChangeStreamPostDeliveryRequestsChangeStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryRequests/change-stream`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON(requestParameters['roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest']),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create a change stream.
     */
    async deliveryRequestCreateChangeStreamPostDeliveryRequestsChangeStream(requestParameters: DeliveryRequestCreateChangeStreamPostDeliveryRequestsChangeStreamRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.deliveryRequestCreateChangeStreamPostDeliveryRequestsChangeStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async deliveryRequestDeleteByIdRaw(requestParameters: DeliveryRequestDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryRequestDeleteById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryRequests/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async deliveryRequestDeleteById(requestParameters: DeliveryRequestDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.deliveryRequestDeleteByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async deliveryRequestExistsGetDeliveryRequestsidExistsRaw(requestParameters: DeliveryRequestExistsGetDeliveryRequestsidExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryRequestExistsGetDeliveryRequestsidExists().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryRequests/{id}/exists`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue));
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async deliveryRequestExistsGetDeliveryRequestsidExists(requestParameters: DeliveryRequestExistsGetDeliveryRequestsidExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
        const response = await this.deliveryRequestExistsGetDeliveryRequestsidExistsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async deliveryRequestExistsHeadDeliveryRequestsidRaw(requestParameters: DeliveryRequestExistsHeadDeliveryRequestsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryRequestExistsHeadDeliveryRequestsid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryRequests/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue));
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async deliveryRequestExistsHeadDeliveryRequestsid(requestParameters: DeliveryRequestExistsHeadDeliveryRequestsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
        const response = await this.deliveryRequestExistsHeadDeliveryRequestsidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async deliveryRequestFindRaw(requestParameters: DeliveryRequestFindRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DeliveryRequest>>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryRequests`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DeliveryRequestFromJSON));
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async deliveryRequestFind(requestParameters: DeliveryRequestFindRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DeliveryRequest>> {
        const response = await this.deliveryRequestFindRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async deliveryRequestFindByIdRaw(requestParameters: DeliveryRequestFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryRequest>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryRequestFindById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryRequests/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryRequestFromJSON(jsonValue));
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async deliveryRequestFindById(requestParameters: DeliveryRequestFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryRequest> {
        const response = await this.deliveryRequestFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find first instance of the model matched by filter from the data source.
     */
    async deliveryRequestFindOneRaw(requestParameters: DeliveryRequestFindOneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryRequest>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryRequests/findOne`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryRequestFromJSON(jsonValue));
    }

    /**
     * Find first instance of the model matched by filter from the data source.
     */
    async deliveryRequestFindOne(requestParameters: DeliveryRequestFindOneRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryRequest> {
        const response = await this.deliveryRequestFindOneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch an existing model instance or insert a new one into the data source.
     */
    async deliveryRequestPatchOrCreateRaw(requestParameters: DeliveryRequestPatchOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryRequest>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryRequests`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: DeliveryRequestToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryRequestFromJSON(jsonValue));
    }

    /**
     * Patch an existing model instance or insert a new one into the data source.
     */
    async deliveryRequestPatchOrCreate(requestParameters: DeliveryRequestPatchOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryRequest> {
        const response = await this.deliveryRequestPatchOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async deliveryRequestPrototypeGetCourierRaw(requestParameters: DeliveryRequestPrototypeGetCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Courier>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryRequestPrototypeGetCourier().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryRequests/{id}/courier`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation courier.
     */
    async deliveryRequestPrototypeGetCourier(requestParameters: DeliveryRequestPrototypeGetCourierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Courier> {
        const response = await this.deliveryRequestPrototypeGetCourierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation courierUser.
     */
    async deliveryRequestPrototypeGetCourierUserRaw(requestParameters: DeliveryRequestPrototypeGetCourierUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CourierUser>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryRequestPrototypeGetCourierUser().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryRequests/{id}/courierUser`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CourierUserFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation courierUser.
     */
    async deliveryRequestPrototypeGetCourierUser(requestParameters: DeliveryRequestPrototypeGetCourierUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CourierUser> {
        const response = await this.deliveryRequestPrototypeGetCourierUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches belongsTo relation deliveryLocation.
     */
    async deliveryRequestPrototypeGetDeliveryLocationRaw(requestParameters: DeliveryRequestPrototypeGetDeliveryLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Town>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryRequestPrototypeGetDeliveryLocation().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryRequests/{id}/deliveryLocation`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TownFromJSON(jsonValue));
    }

    /**
     * Fetches belongsTo relation deliveryLocation.
     */
    async deliveryRequestPrototypeGetDeliveryLocation(requestParameters: DeliveryRequestPrototypeGetDeliveryLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Town> {
        const response = await this.deliveryRequestPrototypeGetDeliveryLocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async deliveryRequestPrototypePatchAttributesRaw(requestParameters: DeliveryRequestPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryRequest>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryRequestPrototypePatchAttributes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryRequests/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: DeliveryRequestToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryRequestFromJSON(jsonValue));
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async deliveryRequestPrototypePatchAttributes(requestParameters: DeliveryRequestPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryRequest> {
        const response = await this.deliveryRequestPrototypePatchAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async deliveryRequestReplaceByIdPostDeliveryRequestsidReplaceRaw(requestParameters: DeliveryRequestReplaceByIdPostDeliveryRequestsidReplaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryRequest>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryRequestReplaceByIdPostDeliveryRequestsidReplace().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryRequests/{id}/replace`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeliveryRequestToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryRequestFromJSON(jsonValue));
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async deliveryRequestReplaceByIdPostDeliveryRequestsidReplace(requestParameters: DeliveryRequestReplaceByIdPostDeliveryRequestsidReplaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryRequest> {
        const response = await this.deliveryRequestReplaceByIdPostDeliveryRequestsidReplaceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async deliveryRequestReplaceByIdPutDeliveryRequestsidRaw(requestParameters: DeliveryRequestReplaceByIdPutDeliveryRequestsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryRequest>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliveryRequestReplaceByIdPutDeliveryRequestsid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryRequests/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DeliveryRequestToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryRequestFromJSON(jsonValue));
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async deliveryRequestReplaceByIdPutDeliveryRequestsid(requestParameters: DeliveryRequestReplaceByIdPutDeliveryRequestsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryRequest> {
        const response = await this.deliveryRequestReplaceByIdPutDeliveryRequestsidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async deliveryRequestReplaceOrCreatePostDeliveryRequestsReplaceOrCreateRaw(requestParameters: DeliveryRequestReplaceOrCreatePostDeliveryRequestsReplaceOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryRequest>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryRequests/replaceOrCreate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeliveryRequestToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryRequestFromJSON(jsonValue));
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async deliveryRequestReplaceOrCreatePostDeliveryRequestsReplaceOrCreate(requestParameters: DeliveryRequestReplaceOrCreatePostDeliveryRequestsReplaceOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryRequest> {
        const response = await this.deliveryRequestReplaceOrCreatePostDeliveryRequestsReplaceOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async deliveryRequestReplaceOrCreatePutDeliveryRequestsRaw(requestParameters: DeliveryRequestReplaceOrCreatePutDeliveryRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryRequest>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryRequests`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DeliveryRequestToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryRequestFromJSON(jsonValue));
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async deliveryRequestReplaceOrCreatePutDeliveryRequests(requestParameters: DeliveryRequestReplaceOrCreatePutDeliveryRequestsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryRequest> {
        const response = await this.deliveryRequestReplaceOrCreatePutDeliveryRequestsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update instances of the model matched by {{where}} from the data source.
     */
    async deliveryRequestUpdateAllRaw(requestParameters: DeliveryRequestUpdateAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingUpdateAll200Response>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryRequests/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeliveryRequestToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingUpdateAll200ResponseFromJSON(jsonValue));
    }

    /**
     * Update instances of the model matched by {{where}} from the data source.
     */
    async deliveryRequestUpdateAll(requestParameters: DeliveryRequestUpdateAllRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingUpdateAll200Response> {
        const response = await this.deliveryRequestUpdateAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     */
    async deliveryRequestUpsertWithWhereRaw(requestParameters: DeliveryRequestUpsertWithWhereRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryRequest>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeliveryRequests/upsertWithWhere`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeliveryRequestToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryRequestFromJSON(jsonValue));
    }

    /**
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     */
    async deliveryRequestUpsertWithWhere(requestParameters: DeliveryRequestUpsertWithWhereRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryRequest> {
        const response = await this.deliveryRequestUpsertWithWhereRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Export delivery requests for a specific date
     */
    async deliveryRequestExportRaw(requestParameters: DeliveryRequestExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        
        if (requestParameters['courierId'] == null) {
            throw new runtime.RequiredError(
                'courierId',
                'Required parameter "courierId" was null or undefined when calling deliveryRequestExport().'
            );
        }

        
        if (requestParameters['date'] == null) {
            throw new runtime.RequiredError(
                'date',
                'Required parameter "date" was null or undefined when calling deliveryRequestExport().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['date'] != null) {
            queryParameters['date'] = requestParameters['date'];
        }

        if (requestParameters['courierId'] != null) {
            queryParameters['courierId'] = requestParameters['courierId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/DeliveryRequests/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Export delivery requests for a specific date
     */
    async deliveryRequestExport(requestParameters: DeliveryRequestExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.deliveryRequestExportRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
